import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=bc8390e4&"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports